<template>
    <div v-if="showModal" class="fixed inset-0 bg-modal flex items-center justify-center z-50 p-4">
        <div class="bg-white rounded-lg w-full max-w-4xl max-h-128 px-6 py-10 md:p-12 items-center relative">
            <!-- ヘッダー -->
            <div class="self-stretch pb-4 border-b border-gray-300 flex justify-between items-center">
                <div class="flex-1 text-gray-700 text-lg font-semibold leading-7 break-words">
                    編集者権限の承認
                </div>
            </div>

            <!-- コンテンツ -->
            <div class="self-stretch px-4 py-12 rounded-lg flex flex-col justify-center items-center">
                <ErrorMessage :message="errorMessage" @clear-message="errorMessage = ''" />
                <div class="self-stretch pt-6 pb-6 flex flex-col justify-start items-center gap-8">
                    <!-- 招待メッセージ -->
                    <div class="flex flex-col justify-start items-start gap-2">
                        <div class="w-[832px] text-center text-gray-600 text-base font-semibold leading-6 break-words">
                            {{ channel.channel_name }}への招待が来ています
                        </div>
                        <div class="w-[832px] flex flex-col justify-start items-center gap-4">
                            <div class="text-gray-700 text-xs font-light leading-4 break-words">
                                記事の作成・編集・公開などの機能が利用可能になります。
                            </div>
                        </div>
                    </div>

                    <!-- ボタン群 -->
                    <div class="flex flex-col justify-start items-center gap-3">
                        <!-- 参加するボタン -->
                        <button class="btn-primary" @click="acceptInvitation">
                            参加する
                        </button>
                        <!-- 辞退するリンク -->
                        <button
                            data-propaty="secondary"
                            data-status="default"
                            class="text-blue-600 text-xs font-light leading-4 break-words"
                            @click="rejectInvitation"
                        >
                            辞退する
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, onMounted, defineEmits } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import ErrorMessage from "./ErrorMessage.vue";

const emit = defineEmits(['accept-invitation']);

const store = useStore();
const showModal = ref(false);
const accessToken = store.state.accessToken;
const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
const invitations = ref([]);
const channel = ref({});
const errorMessage = ref("");

const fetchMemberInvitationRequest = async () => {
    try {
        const response = await axios.get(`${apiEndpoint}/member-invitations/pending/`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status == 200) {
            invitations.value = response.data.results;
            if (invitations.value && invitations.value.length > 0) {
                channel.value = invitations.value[0];
                showModal.value = true;
                // 招待が届いた = 「招待を待つ」状態を解除
                if (store.state.waitForInvitation) {
                    store.commit('setWaitForInvitation', false);
                }
            } else {
                showModal.value = false;
            }
        } else {
            showModal.value = false;
        }
    } catch (error) {
        showModal.value = false;
    }
};

const acceptInvitation = async () => {
    try {
        console.log(channel.value.id);
        const response = await axios.post(`${apiEndpoint}/member-invitations/accept/`, {
            channel_id: channel.value.channel_id,
        },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status == 200) {
            // 招待承認でメンバーになったので hasMembership を更新
            // resolveApplicationRedirect が未申請ユーザーをブロックしないようにする
            if (!store.state.hasMembership) {
                store.commit('setHasMembership', true);
            }
            showModal.value = false;
            emit("accept-invitation");
        }
    } catch (error) {
        errorMessage.value = error.response.data.error;
    }
};

const rejectInvitation = async () => {
    try {
        const response = await axios.post(`${apiEndpoint}/member-invitations/reject/`, {
            channel_id: channel.value.channel_id,
        },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status == 200) {
            showModal.value = false;
        }
    } catch (error) {
        errorMessage.value = error.response.data.error;
    }
};

onMounted(fetchMemberInvitationRequest);
</script>
